import React, { useState, useEffect } from "react";
import "./App.css";
import Nav from "./Navigation/Nav";
import Home from "./Home/Home";
import Company from "./Company/Company";
import Developer from "../src/Developer/Developer";
import ContactForm from "./ContactUs/ContactForm";
import Footer from "./Footer/Footer";
import {
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  Snackbar,
} from "@mui/material";
import Loader from "../src/Loder/Loader"; // Import the Loader component
import "./Button.css";
import Contact_mg from "./contact_us masg/Contact_mg";

// Define your icon components or import them as needed
// Replace these placeholders with your actual icon components
const IconComponent1 = () => <i className="fa-solid fa-icon1"></i>;
const IconComponent2 = () => <i className="fa-solid fa-icon2"></i>;

function App() {
  const [loading, setLoading] = useState(true);

  // State to track dark mode
  const [darkMode, setDarkMode] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // State for Snackbar
  const [massages, setMessage] = useState('');

  useEffect(() => {
    // Simulate loading time; replace this with actual loading logic if needed
    setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the time as needed
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      setSnackbarOpen(true);
      setMessage("Darkmod Is Activated");
    } else {
      setSnackbarOpen(true);
      setMessage("Darkmod Is Deactivated");
    }
  
    // Update the icon for "Enable Darkmod" based on the new state
    const updatedActions = [...actions]; // Create a new array
  
    updatedActions.forEach((action) => {
      if (action.name === "Enable Darkmod") {
        action.icon = darkMode ? <i className="fa-solid fa-moon"></i> : <i className="fa-solid fa-sun"></i>;
      }
    });
  
    // Update the actions array
    setActions(updatedActions);
  };
  
  

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleDownload = () => {
    console.log("Download button clicked"); // Add this line
    window.open(
      "https://play.google.com/store/apps/details?id=com.nakath.aurudu_nakath",
      "_blank" // This option opens the link in a new tab
    );
  };

  // Define your 'actions' array here with icon components
  const [actions, setActions] = useState([
    {
      name: "Enable Darkmod",
      icon: darkMode ? <i className="fa-solid fa-sun"></i> : <i className="fa-solid fa-moon"></i>,
    },
    {
      name: "Download නැකැත් App",
      icon: <i className="fa-brands fa-android"></i>,
    },
    // Add more actions as needed
  ]);
  
  

  return (
    <div  className={darkMode ? "dark-mode" : ""}>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <Nav darkMode={darkMode}/>
          <Home id="home" />
          <Company id="company" />
          <Developer />
          <Contact_mg/>
          <ContactForm id="contact" />
          <Footer />
          <SpeedDial
            ariaLabel=""
            sx={{ position: "fixed", bottom: 16, right: 16 }}
            FabProps={{
              sx: {
                bgcolor: `${darkMode ? "#141414" : ""} ` 
                }
              
            }}
            icon={<SpeedDialIcon />}
          >
            {actions.map((action) => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                onClick={
                  action.name === "Download නැකැත් App"
                    ? handleDownload
                    : action.name === "Enable Darkmod"
                    ? toggleDarkMode
                    : null
                }
              />
            ))}
          </SpeedDial>
        </div>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000} // Adjust the duration as needed
        onClose={closeSnackbar}
        message={massages}
        style={{textAlign:"center"}}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      />
    </div>
  );
}

export default App;
